module.exports = __webpack_public_path__ + "media/site/images/icons/ruby-icon-03ae2b4c573ffb291c5e4c3e5cb2ea49.svg";